import { render, staticRenderFns } from "./sorter.vue?vue&type=template&id=1df3763c&scoped=true&"
import script from "./sorter.vue?vue&type=script&setup=true&lang=ts&"
export * from "./sorter.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df3763c",
  null
  
)

export default component.exports